<div class="tile-container">
  @for (tile of tiles; track tile) {
    @if (!tile.hidden || !tile.hidden()) {
      <div [routerLink]="tile.active ? tile.route : null" class="tile">
        <div
          class="tile-body"
          [style.background-image]="tile.image ? 'url(../../../../../assets/images/' + tile.image + '.jpg)' : null"
          [ngClass]="{ inactive: !tile.active }">
          @if (!tile.isCustomIcon) {
            <fa-icon [icon]="tile.icon" [size]="'4x'"></fa-icon>
          }
          @if (tile.isCustomIcon) {
            <span>Custom Icon</span>
          }
        </div>
        <div class="tile-title">
          {{ tile.name | translate }}
        </div>
      </div>
    }
  }
</div>
